/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { CREATE_TRANSACTION } from "../graphql";
import { VApplication } from "../../../application";
const log: any = LoggerModule?.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICreateTransactionMethods extends IPluginMethodMap {
  createTransaction(args: any): Promise<any>;
}

export class CreateTransactionService implements IAgentPlugin {
  readonly methods: ICreateTransactionMethods;

  constructor() {
    this.methods = {
      createTransaction: this.createTransaction.bind(this),
    };
  }

  async createTransaction(args: any) {
    log.blue(`createTransaction server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("args39", args);
    let data = {
      amount: args?.data?.data?.price,
      currency: args?.data?.data?.currency,
      payOrder: args?.data?.data?.payOrder,
      sessionId: args?.data?.sessionId,
    };
    if (args?.data?.firstName) {
      data["firstName"] = args?.data?.firstName;
    }
    if (args?.data?.lastName) {
      data["lastName"] = args?.data?.lastName;
    }
    if (args?.data?.mobile) {
      data["mobile"] = args?.data?.mobile;
    }
    if (args?.data?.postalCode) {
      data["postalCode"] = args?.data?.postalCode;
    }
    if (args?.data?.countryCode) {
      data["country"] = args?.data?.countryCode.toUpperCase();
    }
    if (args?.data?.city) {
      data["city"] = args?.data?.city;
    }
    if (args?.data?.addressLine1) {
      data["addressLine1"] = args?.data?.addressLine1;
    }
    if (args?.data?.addressLine2) {
      data["addressLine2"] = args?.data?.addressLine2;
    }
    if (args?.data?.email) {
      data["email"] = args?.data?.email;
    }
    if (args?.data?.state) {
      data["state"] = args?.data?.state;
    }
    try {
      if (client) {
        const res = await client.mutate({
          mutation: CREATE_TRANSACTION,
          variables: {
            data: data,
          },
          fetchPolicy: "no-cache",
        });
        console.log("res54", res);
        if (res?.data?.createV2Transaction) {
          if (res?.data?.createV2Transaction?.approvalUrl) {
            return {
              res: res?.data?.createV2Transaction,
              url: res?.data?.createV2Transaction?.approvalUrl,
            };
          } else {
            return {
              res: res?.data?.createV2Transaction,
              url: null,
            };
          }
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      // return {
      //   isEmpty: true,
      // };
    }
  }
}
